/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts
/* import Sales from "layouts/dashboards/sales"; */
import Individual from "customComponents/planningComponents/planning/Individual";
import Global from "customComponents/planningComponents/planning/Global";
import SignInBasic from "layouts/authentication/sign-in/basic";
import Orders from "layouts/pages/orders";
import Order from "layouts/pages/order";
import Accueil from "layouts/pages/home";
import Users from "customComponents/adminComponents/administration/Users";
import Suppliers from "customComponents/adminComponents/administration/Suppliers";
import Models from "customComponents/adminComponents/administration/Models";
import Organisms from "customComponents/adminComponents/administration/Organisms";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Accueil",
    key: "accueil",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/accueil",
    noCollapse: true,
    component: <Accueil />,
  },
  {
    type: "collapse",
    name: "Commandes",
    key: "commandes",
    route: "/commandes",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    component: <Orders />,
    noCollapse: true,
  },
  {
    type: "none",
    name: "Commande",
    key: "commande",
    route: `/commandes/:orderNumber`,
    component: <Order />,
    noCollapse: true,
  },
  /* {
    type: "collapse",
    name: "Indicateurs",
    key: "indicateurs",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    route: "/indicateurs",
    component: <Sales />,
    noCollapse: true,
  }, */
  {
    type: "collapse",
    name: "Planification",
    key: "planification",
    icon: <Icon fontSize="small">table_view</Icon>,
    collapse: [
      {
        name: "Individuelle",
        key: "individuelle",
        route: "/individuelle",
        component: <Individual />,
      },
      {
        name: "Globale",
        key: "globale",
        route: "/globale",
        component: <Global />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Administration",
    key: "administration",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    collapse: [
      {
        name: "Utilisateurs",
        key: "utilisateurs",
        route: "/utilisateurs",
        component: <Users />,
      },
      {
        name: "Fournisseurs",
        key: "fournisseurs",
        route: "/fournisseurs",
        component: <Suppliers />,
      },
      {
        name: "Modèles",
        key: "modeles",
        route: "/modeles",
        component: <Models />,
      },
      {
        name: "Organismes",
        key: "organismes",
        route: "/organismes",
        component: <Organisms />,
      },
    ],
  },
  { type: "divider", key: "divider-1" },
  {
    type: "none",
    name: "Connexion",
    key: "connexion",
    route: "/connexion",
    component: <SignInBasic />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Déconnexion",
    key: "deconnexion",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/connexion",
    component: <SignInBasic />,
    noCollapse: true,
  },
];

export default routes;
